<h2>Multiselect Basic Examples</h2>

<div class="select-grid">
	<div class="select-column">
		<span class="label">Multiselect básico</span>
		<app-multiselect
			[formControl]="multiselectControl"
			[options]="countryOptions"
			placeholder="Selecciona países..."
		/>
		<app-ui-code-block [code]="generateCode({formControl: 'multiselectControl', options: 'countryOptions', placeholder: 'Selecciona países...', size: 'large'})" />
	</div>

	<div class="select-column">
		<span class="label">Multiselect con búsqueda</span>
		<app-multiselect
			[formControl]="multiselectControl"
			[options]="countryOptions"
			placeholder="Selecciona países..."
			[filter]="true"
			filterPlaceholder="Buscar países..."
		/>
		<app-ui-code-block [code]="generateCode({formControl: 'multiselectControl', options: 'countryOptions', placeholder: 'Selecciona países...', size: 'large', filter: true, filterPlaceholder: 'Buscar países...'})" />
	</div>

	<div class="select-column">
		<span class="label">Multiselect modo lista con iconos</span>
		<app-multiselect
			[formControl]="multiselectControl"
			[options]="countryListOptions"
			placeholder="Selecciona países..."
			displayMode="list"
			[showIcon]="true"
			[filter]="true"
			filterPlaceholder="Buscar país..."
		/>
		<app-ui-code-block [code]="generateCode({formControl: 'multiselectControl', options: 'countryListOptions', placeholder: 'Selecciona países...', size: 'large', displayMode: 'list', showIcon: true, filter: true, filterPlaceholder: 'Buscar país...'})" />
	</div>

</div>

<h2>Multiselect Sizes</h2>

<div class="size-grid">
	<div class="size-column">
		<span class="label">Large (64px)</span>
		<app-multiselect
			[formControl]="multiselectControl"
			[options]="countryOptions"
			label="Países"
			size="large"
			placeholder="Selecciona países..."
		/>
		<app-ui-code-block [code]="generateCode({formControl: 'multiselectControl', options: 'countryOptions', label: 'Países', size: 'large', placeholder: 'Selecciona países...'})" />
	</div>

	<div class="size-column">
		<span class="label">Medium (56px)</span>
		<app-multiselect
			[formControl]="multiselectControl"
			[options]="countryOptions"
			label="Países"
			size="medium"
			placeholder="Selecciona países..."
		/>
		<app-ui-code-block [code]="generateCode({formControl: 'multiselectControl', options: 'countryOptions', label: 'Países', size: 'medium', placeholder: 'Selecciona países...'})" />
	</div>

	<div class="size-column">
		<span class="label">Small (48px)</span>
		<app-multiselect
			[formControl]="multiselectControl"
			[options]="countryOptions"
			label="Países"
			size="small"
			placeholder="Selecciona países..."
		/>
		<app-ui-code-block [code]="generateCode({formControl: 'multiselectControl', options: 'countryOptions', label: 'Países', size: 'small', placeholder: 'Selecciona países...'})" />
	</div>
</div>

<h2>Multiselect States</h2>

<div class="size-grid">
	<div class="size-column">
		<span class="label">Normal</span>
		<app-multiselect
			[formControl]="multiselectControl"
			[options]="countryOptions"
			label="Países"
			placeholder="Selecciona países..."
		/>
		<app-ui-code-block [code]="generateCode({formControl: 'multiselectControl', options: 'countryOptions', label: 'Países', placeholder: 'Selecciona países...', size: 'large'})" />
	</div>

	<div class="size-column">
		<span class="label">Disabled</span>
		<app-multiselect
			[formControl]="disabledMultiselectControl"
			[options]="countryOptions"
			label="Países"
			placeholder="Selecciona países..."
			[disabled]="true"
		/>
		<app-ui-code-block [code]="generateCode({formControl: 'disabledMultiselectControl', options: 'countryOptions', label: 'Países', placeholder: 'Selecciona países...', size: 'large', disabled: true})" />
	</div>

	<div class="size-column">
		<span class="label">Error</span>
		<app-multiselect
			[formControl]="errorMultiselectControl"
			[options]="countryOptions"
			label="Países"
			placeholder="Selecciona países..."
			[error]="true"
			errorMessage="Este campo es obligatorio"
		/>
		<app-ui-code-block [code]="generateCode({formControl: 'errorMultiselectControl', options: 'countryOptions', label: 'Países', placeholder: 'Selecciona países...', size: 'large', error: true, errorMessage: 'Este campo es obligatorio'})" />
	</div>
</div>

<h2>Multiselect with Search/Filter</h2>

<div class="size-grid">
	<div class="size-column">
		<span class="label">Large con búsqueda</span>
		<app-multiselect
			[formControl]="multiselectControl"
			[options]="countryOptions"
			label="Países"
			placeholder="Selecciona países..."
			size="large"
			[filter]="true"
			filterPlaceholder="Buscar países..."
		/>
		<app-ui-code-block [code]="generateCode({formControl: 'multiselectControl', options: 'countryOptions', label: 'Países', placeholder: 'Selecciona países...', size: 'large', filter: true, filterPlaceholder: 'Buscar países...'})" />
	</div>

	<div class="size-column">
		<span class="label">Medium con búsqueda</span>
		<app-multiselect
			[formControl]="multiselectControl"
			[options]="countryOptions"
			label="Países"
			placeholder="Selecciona países..."
			size="medium"
			[filter]="true"
			filterPlaceholder="Buscar países..."
		/>
		<app-ui-code-block [code]="generateCode({formControl: 'multiselectControl', options: 'countryOptions', label: 'Países', placeholder: 'Selecciona países...', size: 'medium', filter: true, filterPlaceholder: 'Buscar países...'})" />
	</div>

	<div class="size-column">
		<span class="label">Small con búsqueda</span>
		<app-multiselect
			[formControl]="multiselectControl"
			[options]="countryOptions"
			label="Países"
			placeholder="Selecciona países..."
			size="small"
			[filter]="true"
			filterPlaceholder="Buscar países..."
		/>
		<app-ui-code-block [code]="generateCode({formControl: 'multiselectControl', options: 'countryOptions', label: 'Países', placeholder: 'Selecciona países...', size: 'small', filter: true, filterPlaceholder: 'Buscar países...'})" />
	</div>
</div>
